<script setup lang="ts">
/**
 * Close control for the current offer flow.
 */
const { isCloseVisible, leaveToBackLink } = useFlowExit();
</script>

<template>
    <button
        v-if="isCloseVisible"
        class="flex size-7 items-center justify-center rounded-full bg-shade-3 text-white print:hidden"
        :aria-label="$t('core.buttons.close')"
        data-t-flow-close
        @click="leaveToBackLink"
    >
        <Icon name="tot:x" class="size-4" />
    </button>
</template>
